// components/Features/Features.jsx
import React, { useState, useEffect } from "react";
import "./Features.css";
import "../Partner/PartnerProgram";


const Features = () => {
  const [activeTab, setActiveTab] = useState("offer");
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const section = document.querySelector(".features");
      if (section) {
        const rect = section.getBoundingClientRect();
        setIsVisible(rect.top < window.innerHeight && rect.bottom > 0);
      }
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // const whatWeOffer = [
  //   {
  //     icon: "📋",
  //     text: "Daily Tasks",
  //     description: "Fresh opportunities every day",
  //   },
  //   {
  //     icon: "💰",
  //     text: "Hourly Pay",
  //     description: "Get paid for every hour worked",
  //   },
  //   {
  //     icon: "🕐",
  //     text: "Flexible Hours",
  //     description: "Choose when you want to work",
  //   },
  //   {
  //     icon: "📍",
  //     text: "Location Freedom",
  //     description: "Work from anywhere you prefer",
  //   },
  //   {
  //     icon: "✓",
  //     text: "Verified Partners",
  //     description: "Work with trusted businesses",
  //   },
  //   {
  //     icon: "🌟",
  //     text: "24x7 Support",
  //     description: "We're always here to help",
  //   },
  // ];

  const beAPartnerleft = [
    {
      icon: "🤝",
      text: " Trusted & Reliable Gigs",
      description:
        "Every individual gig is checked and 100% identity-verified for your peace of mind",
    },
    {
      icon: "🏡",
      text: "Your Place, Our Service",
      description:
        "Anytime & Anywhere.",
    },
    
    
    {
      icon: "📊",
      text: " Schedule",
      description:
        "Book at a time Slot as per your Convenience",
    },
    {
      icon: "📞",
      text: "Grow Your Business with us",
      description:
        "Get the extra hands only when you need them ",
    },
    
    
  ];
  const beAPartnerRight = [ 
    {
      icon: "💼",
      text: "Hourly & Time based Billing",
      description:
        "The Real Cost Savings",
    },
    // {
    //   icon: "🔒",
    //   text: "Reliable & Verified",
    //   description:
    //     "Every partner is background-checked and identity-verified for your peace of mind.",
    // },
    
    {
      icon: "⚡",
      text: "Quick Staff Deployment",
      description:
        "No Hiring Commitments, No Recruitment Hassles, Get Workforce instantly during peak hours or emergencies for a day.",
    },
    {
      icon: "🏨",
      text: "Expertise",
      description:
        "Hospitality Services, Task Management & Event Activities",
    },
    {
      icon: "📞",
      text: "24/7 Support",
      description:
        "connect with our support team anytime via chat, email",
    }
  ]

  const stats = [
    { number: "1K+", label: "Active Partners" },
    { number: "99+", label: "Brands & Companies" },
    { number: "95%", label: "Satisfaction Rate" },
    { number: "24/7", label: "Support Available" },
  ];

  return (
    <div>
      
      <section className="features" id="features">
        <div className="features-container">
          {/* Header with animated title */}
          <div className="features-header">
            <h2 className={`features-title ${isVisible ? "animate-in" : ""}`}>
              Why Choose{" "}
              <span className="gradient-text">jobhub manpower solution</span>?
            </h2>
            {/* <p className="features-subtitle">
              India’s First Digital Hospitality Application.
            </p> */}
          </div>

          {/* Stats Section */}
          <div className="stats-grid">
            {stats.map((stat, index) => (
              <div
                key={index}
                className={`stat-card ${isVisible ? "animate-in" : ""}`}
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <h3 className="stat-number">{stat.number}</h3>
                <p className="stat-label">{stat.label}</p>
              </div>
            ))}
          </div>

          {/* Tab Navigation */}


          {/* Main Content */}
          <div className="features-content">
            <div className={`features-grid ${activeTab}`}>
              {/* Left Column - Dynamic based on tab */}
              <div className="features-column">
                {activeTab === "patner" ? (
                  <>
                    {/* <h3 className="column-title">
                      <span className="icon-badge">🎯</span>
                      What We Offer
                    </h3> */}
                    <ul className="features-list">
                      {beAPartnerleft.map((item, index) => (
                        <li
                          key={index}
                          className={`feature-item ${
                            isVisible ? "slide-in-left" : ""
                          }`}
                          style={{ animationDelay: `${index * 0.1}s` }}
                        >
                          <div className="feature-icon-wrapper">
                            <span className="feature-icon">{item.icon}</span>
                          </div>
                          <div className="feature-content">
                            <h4>{item.text}</h4>
                            <p>{item.description}</p>
                          </div>
                        </li>
                      ))}
                    </ul>
                  </>
                ) : (
                  <>
                    <h3 className="column-title">
                      <span className="icon-badge">🚀</span>
                      Be a Partner
                    </h3>
                    <ul className="features-list">
                      {beAPartnerleft.map((item, index) => (
                        <li
                          key={index}
                          className={`feature-item ${
                            isVisible ? "slide-in-left" : ""
                          }`}
                          style={{ animationDelay: `${index * 0.1}s` }}
                        >
                          <div className="feature-icon-wrapper">
                            <span className="feature-icon">{item.icon}</span>
                          </div>
                          <div className="feature-content">
                            <h4 className="feature-title">{item.text}</h4>
                            <p className="feature-description">
                              {item.description}
                            </p>
                          </div>
                        </li>
                      ))}
                    </ul>
                  </>
                )}
              </div>

              {/* Center Image */}
              <div className="features-image-container">
                <div
                  className={`features-image ${isVisible ? "scale-in" : ""}`}
                >
                  <div className="image-wrapper">
                    <div className="floating-icons">
                      <span
                        className="floating-icon"
                        style={{ top: "10%", left: "10%" }}
                      >
                        💰
                      </span>
                      <span
                        className="floating-icon"
                        style={{ top: "20%", right: "15%" }}
                      >
                        🚀
                      </span>
                      <span
                        className="floating-icon"
                        style={{ bottom: "20%", left: "15%" }}
                      >
                        ⭐
                      </span>
                      <span
                        className="floating-icon"
                        style={{ bottom: "10%", right: "10%" }}
                      >
                        📱
                      </span>
                    </div>
                    <div className="yellow-circle">
                      <img
                        src="/api/placeholder/400/400"
                        alt="jobhub manpower solution Team"
                      />
                    </div>
                    <div className="logo-badge">
                      <span className="badge-text">
                        jobhub manpower solution
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Right Column - Contact CTA */}
              <div className="features-column cta-column">
                <ul className="features-list-right">
                      {beAPartnerRight.map((item, index) => (
                        <li
                          key={index}
                          className={`feature-item ${
                            isVisible ? "slide-in-left" : ""
                          }`}
                          style={{ animationDelay: `${index * 0.1}s` }}
                        >
                          <div className="feature-icon-wrapper">
                            <span className="feature-icon">{item.icon}</span>
                          </div>
                          <div className="feature-content">
                            <h4>{item.text}</h4>
                            <p>{item.description}</p>
                          </div>
                        </li>
                      ))}
                    </ul>
              </div>
            </div>
          </div>

          {/* Bottom CTA Section */}
          {/* <div className="features-bottom-cta">
            <h3>Start Your Journey Today!</h3>
            <p>Download the jobhub manpower solution app and start earning</p>
            <div className="app-buttons">
              <button className="app-store-btn">
                <img
                  src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
                  alt="Get it on Google Play"
                />
              </button>
              <button className="app-store-btn">
                <img
                  src="https://upload.wikimedia.org/wikipedia/commons/3/3c/Download_on_the_App_Store_Badge.svg"
                  alt="Download on App Store"
                />
              </button>
            </div>
          </div> */}
        </div>
      </section>
    </div>
  );
};

export default Features;
